import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CModal, ModalFilterUser } from "../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../context";
import { DeleteLocationApi, LocationApi, QRExport } from "../../api";
import { Link } from 'react-router-dom'

export const Location = () => {
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleDelete, setVisibleDelete] = useState<boolean>(false)
    const [selectDelete, setSelectDelete] = useState<any>(null)
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "نام موقعیت مکانی ",
            render: (i: any) => (<div className="h-[40px] flex items-center">{i.name && i.name != null && i.name}</div>)
        },
        {
            title: "توضیحات ",
            render: (i: any) => (<>{i.description && i.description != null && i.description}</>)
        },
        {
            title: "کد QR",
            render: (i: any) => (<>{i.code && i.code != null && <img src={`https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${i.code}`} className="h-[70px] w-[70px] mr-5" />}</>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex items-center w-full justify-center ">
                    <img onClick={() => downloadQR(i.id)} src="/assetes/svg/download.svg" className="w-[20px] mx-[7px] cursor-pointer" />
                    <img onClick={() => prictQR(i.id)} src="/assetes/svg/print.svg" className="w-[20px] mx-[7px] cursor-pointer" />
                    <Link to={`/p/location/${i.id}`}>
                        <img src="/assetes/svg/edit.svg" className="w-[20px] mx-[7px] cursor-pointer" />
                    </Link>
                    <img src="/assetes/svg/trash.svg" onClick={() => startDelete(i.id)} className="w-[20px] mx-[7px] cursor-pointer" />
                </div>)
        },

    ]

    const prictQR = async (id: any) => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await QRExport(id)
        CtxLoad.setDisplayLoadingBlur(false)
        var printWindow: any = window.open('', '');
        printWindow.document.write('<html><head><title></title>');
        printWindow.document.write('</head><body ><img src=\'');
        printWindow.document.write(res);
        printWindow.document.write('\' /></body></html>');
        printWindow.document.close();
        printWindow.print();
        printWindow.close()
    }

    const downloadQR = async (id: any) => {
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await QRExport(id)
        CtxLoad.setDisplayLoadingBlur(false)
        var el = document.createElement("a");
        el.setAttribute("href", res);
        el.setAttribute("download", 'qr_code');
        el.setAttribute("target", '_blank');
        document.body.appendChild(el);
        el.click();
        el.remove();
    }

    const startDelete = (id: any) => {
        setSelectDelete(id)
        setVisibleDelete(true)
    }

    const DeleteRoll = async () => {
        CtxLoad.setDisplayLoadingBtn(true)
        let res = await DeleteLocationApi(selectDelete)
        CtxLoad.setDisplayLoadingBtn(false)
        if (res.success) {
            toast("با موفقیت حذف گردید", { type: "success" })
            setSelectDelete(null)
            setVisibleDelete(false)
            getData()
        }
        else {
            toast("خطایی رخ داده است", { type: "error" })
        }
    }


    const getData = async () => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await LocationApi()
            setTableData(res.data)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "موقعیت های مکانی | دایان"
        CtxNav.setActiveMenuItem({ 'item': 5, 'subItem': 0, })
        getData()

    }, [])

    return (
        <div className=" w-full flex flex-col">

            <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                <h1 className="sm:text-2xl text-lg font-bold mb-[30px] md:mb-0">مدیریت موقعیت‌های مکانی</h1>
                <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                    <button className=" w-full md:w-fit sm:px-[40px] px-[10px] h-[35px] md:h-[45px] bg-dayan-gray-200 rounded-md md:text-sm text-[11px] text-white">
                        <Link to='/p/location/add' className=" w-full h-full flex justify-center items-center">
                            + ایجاد موقعیت مکانی
                        </Link>
                    </button>
                </div>
            </div>

            <div className=" w-full mt-[20px]">
                {CtxLoad.displayLoadingSkelton == false ?
                    <TablePage columns={col} data={tableData} />
                    :
                    <CSkeletonTable />
                }
            </div>

            <ModalDelete visible={visibleDelete} setVisible={setVisibleDelete} onOk={DeleteRoll} loading={CtxLoad.displayLoadingBtn} />

        </div>
    )
}
